import React from 'react';
import { Tabs, Transfer } from 'antd';
// import components
import TagList from '../elements/Component.TagList';

const TabPane = Tabs.TabPane;

class IsotopeLabelsTab extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      lightData: [],
      lightKeys: [],
      mediumData: [],
      mediumKeys: [],
      heavyData: [],
      heavyKeys: [],
    }
  }
  
  componentDidMount(){
    const {parameters, isotopeLabels} = this.props;
    
    let lightIsotopeData = getIsotopeData(isotopeLabels, parameters.lightIsotope);
    let mediumIsotopeData = getIsotopeData(isotopeLabels, parameters.mediumIsotope);
    let heavyIsotopeData = getIsotopeData(isotopeLabels, parameters.heavyIsotope);

    this.setState({
      lightData: lightIsotopeData.isotopeData,
      lightKeys: lightIsotopeData.isotopeKeys,
      mediumData: mediumIsotopeData.isotopeData,
      mediumKeys: mediumIsotopeData.isotopeKeys,
      heavyData: heavyIsotopeData.isotopeData,
      heavyKeys: heavyIsotopeData.isotopeKeys,
    });
  }

  filterOption = (inputValue, option) => {
    return option.description.indexOf(inputValue) > -1;
  }

  handleLightChange = (lightKeys) => {
    this.setState({lightKeys});
    this.props.updateParameters({lightIsotope: [...lightKeys]});
  }

  handleMediumChange = (mediumKeys) => {
    this.setState({mediumKeys});
    this.props.updateParameters({mediumIsotope: [...mediumKeys]});
  }

  handleHeavyChange = (heavyKeys) => {
    this.setState({heavyKeys});
    this.props.updateParameters({heavyIsotope: [...heavyKeys]});
  }

  callback(key){
    // console.log(key);
  }

  render(){
    // console.log('rendering...');
    // console.log(this.props);
    // console.log(this.state);

    return (
      <div>
        <div className="parameters-subcategory-title-wrapper">
          <div>Set Isotope Labels</div>
        </div>

        <Tabs defaultActiveKey="1" onChange={this.callback}>
          <TabPane tab="Light Isotopes" key="1">
            
            <Transfer
              listStyle={{
                width: '45%',
                height: 400,
              }}
              dataSource={this.state.lightData}
              showSearch
              filterOption={this.filterOption}
              targetKeys={this.state.lightKeys}
              onChange={this.handleLightChange}
              render={item=>item.title}>
            </Transfer>

            <TagList 
              title="Selected light isotopes"
              color="#108ee9"
              list={this.state.lightKeys}
            />
          </TabPane>

          <TabPane tab="Medium Isotopes" key="2">
              
            <Transfer
              listStyle={{
                width: '45%',
                height: 400,
              }}
              dataSource={this.state.mediumData}
              showSearch
              filterOption={this.filterOption}
              targetKeys={this.state.mediumKeys}
              onChange={this.handleMediumChange}
              render={item=>item.title}>
            </Transfer>

            <TagList 
              title="Selected medium isotopes"
              color="#108ee9"
              list={this.state.mediumKeys}
            />
          </TabPane>

          <TabPane tab="Heavy Isotopes" key="3">
              
            <Transfer
              listStyle={{
                  width: '45%',
                  height: 400,
              }}
              dataSource={this.state.heavyData}
              showSearch
              filterOption={this.filterOption}
              targetKeys={this.state.heavyKeys}
              onChange={this.handleHeavyChange}
              render={item=>item.title}>
            </Transfer>

            <TagList 
              title="Selected heavy isotopes"
              color="#108ee9"
              list={this.state.heavyKeys}
            />
          </TabPane>
            
        </Tabs>
      </div>
    );
  }
}

export default IsotopeLabelsTab;

IsotopeLabelsTab.defaultProps = {
  paramters: {
    lightIsotope: [],
    mediumIsotope: [],
    heavyIsotope: []
  },
  isotopeLabels: []
}

const getIsotopeData = (isotopeLabels, defaultKeys) => {
  const isotopeKeys = [];
  const isotopeData = [];
  for (let i = 0; i < isotopeLabels.length; i++){
    const data = {
      key: `${isotopeLabels[i]["isotope"]}`,
      title: `${isotopeLabels[i]["isotope"]}`,
      description: `description of content ${isotopeLabels[i]["isotope"]}`,
      chosen: defaultKeys.indexOf(isotopeLabels[i]["isotope"]) > -1,
    };
    if(data.chosen){isotopeKeys.push(data.key);}
    isotopeData.push(data);
  }
  return {isotopeData, isotopeKeys};
}

